import { render } from "./LeaderboardsPage.vue?vue&type=template&id=71d51109&scoped=true"
import script from "./LeaderboardsPage.vue?vue&type=script&lang=js"
export * from "./LeaderboardsPage.vue?vue&type=script&lang=js"

import "./LeaderboardsPage.vue?vue&type=style&index=0&id=71d51109&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d51109"]])

export default __exports__